import { PAINTER_NOTIFICATION_TYPES } from '@paintscout/util/users'
import type { UserPreferencesDocument } from 'paintscout'
import type { PainterNotificationPrefs } from '../PainterScheduleView'

const PAINTER_NOTIFICATION_PREF_KEYS = {
  jobAssigned: PAINTER_NOTIFICATION_TYPES.jobAssigned,
  jobUpdated: PAINTER_NOTIFICATION_TYPES.jobUpdated,
  jobCancelled: PAINTER_NOTIFICATION_TYPES.jobCancelled,
  taskAssigned: PAINTER_NOTIFICATION_TYPES.taskAssigned,
  taskDueDaily: PAINTER_NOTIFICATION_TYPES.taskDueDaily,
  taskDueWeekly: PAINTER_NOTIFICATION_TYPES.taskDueWeekly
} as const

export function getPainterNotificationPrefs(preferences?: UserPreferencesDocument): PainterNotificationPrefs {
  return Object.entries(PAINTER_NOTIFICATION_PREF_KEYS).reduce<PainterNotificationPrefs>((acc, [key, type]) => {
    acc[key as keyof PainterNotificationPrefs] = preferences?.notifications?.types?.[type]?.enabled ?? false
    return acc
  }, {})
}

export function mergePainterNotificationPrefs(
  preferences: UserPreferencesDocument,
  prefs: PainterNotificationPrefs
): UserPreferencesDocument {
  const nextTypes = { ...(preferences.notifications?.types ?? {}) }

  for (const [key, type] of Object.entries(PAINTER_NOTIFICATION_PREF_KEYS)) {
    const enabled = prefs[key as keyof PainterNotificationPrefs]
    if (enabled === undefined) continue

    nextTypes[type] = {
      ...nextTypes[type],
      enabled,
      triggeredBy: nextTypes[type]?.triggeredBy ?? 'self'
    }
  }

  return {
    ...preferences,
    notifications: {
      ...(preferences.notifications ?? {}),
      enabled: preferences.notifications?.enabled ?? true,
      types: nextTypes
    }
  }
}
